import { debounce } from '../utils.js';
import { onLoad } from '../utils/onLoad';

const SCROLL_THRESHOLD = 1500;
let loading = false, page = 1;

const loadPage = (href) => {
    loading = true;

    const url = new URL(href, window.location.href);
    const searchParams = new URL(window.location.href).searchParams;

    searchParams.forEach((value, field) => {
        if(!url.searchParams.has(field)) {
            url.searchParams.set(field, value);
        }
    });

    url.searchParams.set('js-scroll', 1);
    url.searchParams.set('pag', ++page);

    fetch(url.href)
        .then(response => response.text())
        .then(content => {
            document.querySelector('.js-infinite-scroll-content').insertAdjacentHTML('beforeend', content);
            loading = false;

            const paramsConfig = document.getElementById('js-config');
            const dynamicConfigs = document.querySelectorAll('.js-dynamic-config');
            if (dynamicConfigs.length) {
                const latestConfig = dynamicConfigs[dynamicConfigs.length - 1].content.cloneNode(true);
                paramsConfig.textContent = latestConfig.textContent;
            }

            document.dispatchEvent(new CustomEvent('infinite-scroll-load', {
                detail: {
                    url: url.href,
                    content: content,
                    currentPage: page
                }
            }));
        })
        .catch(() => {
            loading = false;
        });
};

onLoad( () => {
    const infiniteScrollContent = document.querySelector('.js-infinite-scroll-content');
    if (!infiniteScrollContent) return;

    const feedTotalPages = document.querySelector('.js-infinite-scroll')?.dataset.feedTotalPages;
    const finalFeedElement = document.querySelector('.last-element-feed');
    const hasVerticalScroll = document.documentElement.scrollHeight > document.documentElement.clientHeight;

    if (!hasVerticalScroll && feedTotalPages && finalFeedElement.classList.contains('d-none')) {
        finalFeedElement.classList.remove('d-none');
    }

    document.addEventListener('click', (e) => {
        if (e.target.closest('.js-infinite-scroll [data-scroll-page] a')) {
            document.location.hash = e.target.closest('[data-scroll-page]').getAttribute('id');
        }
    });

    let previousScroll = window.scrollY;

    window.addEventListener('scroll', debounce(() => {
        const scrollingDown = previousScroll < window.scrollY;
        previousScroll = window.scrollY;

        if (loading) return;
        const paginationContainers = document.querySelectorAll('.js-infinite-scroll-content .pagination');
        const lastPaginationContainer = paginationContainers[paginationContainers.length- 1];

        const rect = infiniteScrollContent.getBoundingClientRect();
        if (scrollingDown && (rect.bottom - window.innerHeight - SCROLL_THRESHOLD < 0)) {
            const nextLink = lastPaginationContainer?.querySelector('a.next');
            
            if (nextLink) {
                loadPage(nextLink.href);
            } else {
                if (finalFeedElement?.classList.contains('d-none') && page > 1) {
                    finalFeedElement.classList.remove('d-none');
                }
            }
        }

        document.querySelectorAll('.js-infinite-scroll-content .pagination').forEach(pagination => {
            pagination.classList.add('d-none');
        });
    }, 50));

    document.location.hash = document.location.hash;
});
